export default __webpack_public_path__ + "static/media/slider1.156d9562.jpg";